import { useBeeswaxList } from "@/modules/BeeswaxList/beeswaxList.hook";

export function useAppSiteData({
  isEdit,
  areFilters,
}: {
  isEdit: boolean;
  areFilters: Record<string, boolean>;
}) {
  const {
    data: domainList,
    isLoading: domainListLoading,
    isFetching: domainListFetching,
  } = useBeeswaxList(
    {
      queryParams: { type: "domain" },
      options: { enabled: isEdit && areFilters?.domain_list },
    },
    "withType"
  );
  const {
    data: dealList,
    isLoading: dealListLoading,
    isFetching: dealListFetching,
  } = useBeeswaxList(
    {
      queryParams: { type: "deal_id" },
      options: { enabled: isEdit && areFilters?.deal_id_list },
    },
    "withType"
  );
  return {
    domainList,
    domainListLoading: domainListLoading && domainListFetching,
    dealList,
    dealListLoading: dealListLoading && dealListFetching,
  };
}
